/** The 39 launch languages (decision D7), in the order of the language picker. */
export interface Language {
  code: string;
  native: string;
  english: string;
}

export const LANGUAGES: readonly Language[] = [
  { code: 'en', native: 'English', english: 'English' },
  { code: 'de', native: 'Deutsch', english: 'German' },
  { code: 'fr', native: 'Français', english: 'French' },
  { code: 'es', native: 'Español', english: 'Spanish' },
  { code: 'it', native: 'Italiano', english: 'Italian' },
  { code: 'pt', native: 'Português', english: 'Portuguese' },
  { code: 'nl', native: 'Nederlands', english: 'Dutch' },
  { code: 'pl', native: 'Polski', english: 'Polish' },
  { code: 'cs', native: 'Čeština', english: 'Czech' },
  { code: 'sk', native: 'Slovenčina', english: 'Slovak' },
  { code: 'hu', native: 'Magyar', english: 'Hungarian' },
  { code: 'ro', native: 'Română', english: 'Romanian' },
  { code: 'bg', native: 'Български', english: 'Bulgarian' },
  { code: 'el', native: 'Ελληνικά', english: 'Greek' },
  { code: 'da', native: 'Dansk', english: 'Danish' },
  { code: 'sv', native: 'Svenska', english: 'Swedish' },
  { code: 'nb', native: 'Norsk bokmål', english: 'Norwegian' },
  { code: 'fi', native: 'Suomi', english: 'Finnish' },
  { code: 'is', native: 'Íslenska', english: 'Icelandic' },
  { code: 'et', native: 'Eesti', english: 'Estonian' },
  { code: 'lv', native: 'Latviešu', english: 'Latvian' },
  { code: 'lt', native: 'Lietuvių', english: 'Lithuanian' },
  { code: 'sl', native: 'Slovenščina', english: 'Slovenian' },
  { code: 'hr', native: 'Hrvatski', english: 'Croatian' },
  { code: 'bs', native: 'Bosanski', english: 'Bosnian' },
  { code: 'sr', native: 'Српски', english: 'Serbian' },
  { code: 'mk', native: 'Македонски', english: 'Macedonian' },
  { code: 'sq', native: 'Shqip', english: 'Albanian' },
  { code: 'uk', native: 'Українська', english: 'Ukrainian' },
  { code: 'ru', native: 'Русский', english: 'Russian' },
  { code: 'be', native: 'Беларуская', english: 'Belarusian' },
  { code: 'tr', native: 'Türkçe', english: 'Turkish' },
  { code: 'mt', native: 'Malti', english: 'Maltese' },
  { code: 'ga', native: 'Gaeilge', english: 'Irish' },
  { code: 'cy', native: 'Cymraeg', english: 'Welsh' },
  { code: 'ca', native: 'Català', english: 'Catalan' },
  { code: 'eu', native: 'Euskara', english: 'Basque' },
  { code: 'gl', native: 'Galego', english: 'Galician' },
  { code: 'ja', native: '日本語', english: 'Japanese' },
];

/** Languages whose script Nunito lacks; they load M PLUS Rounded 1c. */
export const NEEDS_FALLBACK_FONT = new Set(['el', 'ja']);
